import { helper } from "../../lib/helper";

export const aboutMsc = {
  init(origin, destination, direction) {
    aboutMsc.setVideoBg(destination);

    aboutMsc.scrollBlock(origin, destination, direction);

    // Set the static logo visibility
    if ($(destination.item).hasClass('js-about-msc') || $(destination.item).hasClass('js-blue-msc-label')) {
      $('#staticAboutMscLogo').addClass('js-animate-completed');
    } else {
      $('#staticAboutMscLogo').removeClass('js-animate-completed').addClass('d-lg-none');

      setTimeout(() => {
        $('#staticAboutMscLogo').removeClass('d-lg-none');
      }, 1000);
    }
  },
  setVideoBg(destination) {
    if ($(destination.item).hasClass('js-about-msc') && $(destination.item).hasClass('js-has-video')) {
      helper.videoController('play', $('.js-about-msc video'));
    } else {
      setTimeout(() => {
        helper.videoController('stop', $('.js-about-msc video'));
      }, 1000);
    }
  },
  scrollBlock(origin, destination, direction) {

    if ($(window).innerWidth() >= 979.98) {
      // Lock scrolling
      if (direction == 'down') {
        if ($(destination.item).hasClass('js-about-msc')) {
          fullpage_api.setAllowScrolling(false);
        } else {
          $('.js-block-b').addClass('hide').prop('style', '').find('.animated').removeClass('js-animate-completed');
        }
      }

      // Lock scrolling
      if (direction == 'up') {
        if ($(destination.item).hasClass('js-about-msc')) {
          fullpage_api.setAllowScrolling(false);
        } else {
          $('.js-block-b').addClass('hide').prop('style', '').find('.animated').removeClass('js-animate-completed');
        }
      }

      $('.js-about-msc').bind('mousewheel', function (e) {
        if (e.originalEvent.wheelDelta < 0) {
          /**
           * Remove the visibility class on .js-block-a which by default added by the fullpage.js onLeave and onLoad method
          */
          $('.js-block-b').find('.animated').removeClass('js-animate-completed');

          /**
           * 1. Hide the first block after scrolling down
          */

          $('.js-block-a').find('.animated').removeClass('js-animate-completed');

          /**
           * 2. Reveal the second block after scrolling down
          */

          setTimeout(() => {
            if ($('.js-block-a').find('.animated').hasClass('js-animate-completed') === false) {
              $('.js-block-b').fadeIn(function () {
                $(this).find('.animated').addClass('js-animate-completed');
                fullpage_api.setAllowScrolling(true);
              });
            }
          }, 1000);

        } else {
          /**
          * Remove the visibility class on .js-block-a which by default added by the fullpage.js onLeave and onLoad method
         */
          $('.js-block-b').find('.animated').removeClass('js-animate-completed');

          /**
           * 1. Hide the first block after scrolling down
          */

          $('.js-block-a').find('.animated').removeClass('js-animate-completed');

          /**
           * 2. Reveal the second block after scrolling down
          */

          setTimeout(() => {
            if ($('.js-block-a').find('.animated').hasClass('js-animate-completed') === false) {
              $('.js-block-b').fadeIn(function () {
                $(this).find('.animated').addClass('js-animate-completed');
                fullpage_api.setAllowScrolling(true);
              });
            }
          }, 1000);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/featured/sustainability/modules/aboutMsc.js